import { render, staticRenderFns } from "./globalStrategy2.vue?vue&type=template&id=d3b9349a&scoped=true&"
import script from "./globalStrategy2.vue?vue&type=script&lang=js&"
export * from "./globalStrategy2.vue?vue&type=script&lang=js&"
import style0 from "./globalStrategy2.vue?vue&type=style&index=0&id=d3b9349a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b9349a",
  null
  
)

export default component.exports